import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { queryKeys } from '../fax-queries';

export const useInvalidateFaxCount = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    const countKey = [...queryKeys.base, 'count'];
    queryClient.invalidateQueries(countKey);
  }, [queryClient]);
};
